import styled from "styled-components";
import {MEDIA_QUERIES} from "constants/StyleConstants.js";
import {StyleImg} from "components/Common/StyleImg";

export const Logo = styled(StyleImg).attrs(() => ({
  src: "/assets/images/waterspeed-nav-logo.png",
  alt: "waterspeed-logo"
}))`
  width: 50px;
  height: 50px;
  margin: 0px 0px 50px 0px;

  @media only screen and (min-width: ${MEDIA_QUERIES.tablet_min_width}) and (max-width: ${MEDIA_QUERIES.tablet_max_width}) {
    width: 70px;
    height: 70px;
  }

  @media only screen and (min-width: ${MEDIA_QUERIES.tablet_max_width}) {
    display: none;
  }
`;
